export default __webpack_public_path__ + "static/media/client6.0d9fa6f9.png";